export default "__VITE_ASSET__FFiK_svl__"